import { render, staticRenderFns } from "./ProductsTableList.vue?vue&type=template&id=5b4f2d81&"
import script from "./ProductsTableList.vue?vue&type=script&lang=js&"
export * from "./ProductsTableList.vue?vue&type=script&lang=js&"
import style0 from "./ProductsTableList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports